import ApplicationDevelopment from './Template'

export default ApplicationDevelopment
